import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { retry } from 'rxjs/operators';
import { BlobResponse } from '../../Models/OtherClasses';

@Injectable()
export class PaymentService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Payment');
	}

	loadAll(): Observable<ePM.Logic.Payment[]> {
		return this.myBaseService.loadAll(this.url);
	}
	loadAllForCompany(id: System.Guid): Observable<ePM.Logic.Payment[]> {
		return this.myBaseService.loadAll(this.url + '/LoadAll/' + id);
	}
	getReceipt(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.returnBlob(null, this.url + '/Receipt/' + id);
	}
	save(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.Payment> {
		return this.myBaseService.save(tempItem, this.url);
	}
	saveExisting(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.Payment> {
		return this.myBaseService.save(tempItem, this.url + '/Save');
	}
	saveCC(tempItem: ePM.Logic.CCInfo): Observable<ePM.Logic.CCInfo> {
		return this.myBaseService.post(tempItem, this.url + '/SaveCC');
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.Payment> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<ePM.Logic.Payment> {
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string): Observable<ePM.Logic.Payment[]> {
		return this.myBaseService.post(searchTerm, this.url + '/Search');
	}
	runDateReport(searchItem: ePM.Logic.DateSearch): Observable<ePM.Logic.Payment[]> {
		return this.myBaseService.post(searchItem, this.url + '/ByDates');
	}
}
